"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EmailGeneralHandler", {
    enumerable: true,
    get: function() {
        return EmailGeneralHandler;
    }
});
const _longtextgeneralhandler = require("../long-text/long-text.general.handler");
let EmailGeneralHandler = class EmailGeneralHandler extends _longtextgeneralhandler.LongTextGeneralHandler {
};
